import { Image } from "expo-image";
import { Box, Button, Modal, Toast, View } from "native-base";
import { useEffect, useState } from "react";
import { ActivityIndicator, Platform, Text, TouchableHighlight, TouchableOpacity } from "react-native";
import Entypo from '@expo/vector-icons/Entypo';
import Fontisto from '@expo/vector-icons/Fontisto';
import { useDispatch } from "react-redux";
// import * as Toast from ""

import { useTypedSelector } from "../../redux/store";
import { PayAPI } from "../../data/payApi";

export const PayTipModal = ({
  open,
  setOpen,
  tipText,
  delCoins,
  onChange
}:{
  open: boolean;
  setOpen: (open: boolean) => void;
  tipText: string;
  delCoins: number;
  onChange: (state: string)=> void;
}) => {
  const dispatch = useDispatch();
  const userCurrent = useTypedSelector((state) => state.userCurrent);
  const [noMoreCoin, setNoMoreCoin] = useState(false);
  const [payLoad, setPayLoad] = useState(false);

  const PayCoins = async ()=>{
    if(payLoad) return;
    if(noMoreCoin){
      onChange("error")
    }else{
      setPayLoad(true);
      let res = await PayAPI.modifyCoins(dispatch, -delCoins);
      setPayLoad(false);
      
      if(!res || typeof res === "string"){
        Toast.show({
          title: "Pay failed",
          placement: "top",
          bgColor: "rgba(255,0,0,0.4)"
        });
        return;
      };
      Toast.show({
        title: "Pay Success",
        placement: "top",
        bgColor: "rgba(0,255,0,0.4)",
      });
      onChange("success");
    }
  };

  useEffect(()=>{
    setNoMoreCoin( userCurrent.coins < delCoins );
  },[open, userCurrent]);

  return (
    <Modal isOpen={open} size="full" bg="black.700:alpha.70"
      justifyContent="center" alignItems="center"
      style={{
        width: "100%", maxWidth: 460,
        marginLeft: "auto", marginRight: "auto",
      }}>
      <Modal.CloseButton _icon={{ color: "white" }} position="absolute"
        right={2} top={Platform.OS === 'ios' ? 12 : 2} zIndex={2}
        onPress={()=>{setOpen(false)}} />

      <View style={{ width: "100%", alignItems: "center" }}>
        
        <Entypo name="lock-open" size={48}
          style={{
            fontWeight: "900"
          }}
          color="#FFFFFF" />
        <Text style={{
          color: "#FFFFFF", fontSize: 18, fontWeight: "bold",
          marginBottom: 16, marginTop: 8,
          textAlign: "center"
        }}>
          {tipText}
        </Text>
        <Box style={{
          flexDirection: "row", gap: 10, alignItems: "center",
        }}>
          <Box style={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: 10,
            borderRadius: 20,
            padding: 2,
            paddingLeft: 12,
            paddingRight: 12,
            borderWidth: 1,
            borderColor: "#007AFF",
            borderStyle: "solid"
          }}>
            <Fontisto name="database" size={16} color="#FFFFFF" />
            <Text style={{
              color: "#FFFFFF", fontSize: 18, fontWeight: "bold",
            }}>{userCurrent.coins}</Text>
          </Box>
          <Text style={{
            color: "#DD0000", fontSize: 18, fontWeight: "bold",
          }}>- {delCoins} Coin</Text>
        </Box>
        <View style={{ height: 60, padding: 10, marginTop: 20 }}>  
          { noMoreCoin && (
            <Box>
              <Text style={{
                color: "#FFFFFF", fontSize: 12,
                marginBottom: 10, textAlign: "center"
              }}>You don't have enough coins</Text>
            </Box>
          ) }
          <TouchableHighlight style={{
            height: 40, borderRadius: 6, paddingLeft: 10, paddingRight: 10,
            width: 200,
            backgroundImage: "linear-gradient(to bottom, rgb(148,9,255), rgb(173,8,255))",
            alignItems: "center", justifyContent: "center"
          }} onPress={PayCoins}>
            {payLoad ? (
              <ActivityIndicator size="large" color="#FFFFFF" />
            ):(
              <Text style={{
                fontSize: 18, color: "#FFFFFF", fontWeight: "700"
              }}>
                { noMoreCoin ? "Purchase coins" : "Pay " + delCoins + " Coins" }
              </Text>
            )}
          </TouchableHighlight>
        </View>
      </View>
    </Modal>
  )
};